module.exports = __webpack_public_path__ + "static/media/jeux.867975d3.webp";